module.exports = __webpack_public_path__ + "static/media/rounded-rect-disabled.f8235011.png";